import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './pc-story-card.css.lit';

/**
 * Story card component
 * @element pc-story-card
 * @slot - This element has a default slot
 */
@customElement('pc-story-card')
export class PCStoryCard extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  slots = new SlotsController(this);

  render(): TemplateResult {
    return html`
      <div class="story-card">
        ${this.slots.conditionalSlot('title', false)}
        ${this.slots.conditionalSlot('description', false)}
        ${this.querySelector('[slot="cta"]') !== null
          ? html`
              <div class="cta-wrapper">
                <slot name="cta"></slot>
              </div>
            `
          : null}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-story-card': PCStoryCard;
  }
}
